@use "source/webComponent/theme" as *;
.root {
  display: flex;
  flex-direction: column;
  gap: $spacine_px;
}